import { render, staticRenderFns } from "./TestPrepSelector.vue?vue&type=template&id=2069d4bc&scoped=true&"
import script from "./TestPrepSelector.vue?vue&type=script&lang=js&"
export * from "./TestPrepSelector.vue?vue&type=script&lang=js&"
import style0 from "./TestPrepSelector.vue?vue&type=style&index=0&id=2069d4bc&prod&lang=scss&"
import style1 from "./TestPrepSelector.vue?vue&type=style&index=1&id=2069d4bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2069d4bc",
  null
  
)

export default component.exports